export default __webpack_public_path__ + "static/char-35-anr-ae3cd7c7a0719dfa0bf68fe64b736e04.webp";